import React, { useState } from "react";
import classes from "./Input.module.scss";
import moment from "moment";
import passwordEyeIconOn from "../../../../assets/images/LoginIcons/eyeIconOn.svg";
import passwordEyeIconOff from "../../../../assets/images/LoginIcons/eyeIconOff.svg";
import useComponentVisible from "../../../../hooks/useComponentVisible";
import { useEffect } from "react";
import Dropdown from "../Dropdown/Dropdown";
import Button from "../../Button/Button";
import { FormattedMessage } from "react-intl";

const Input = ({
  value,
  label,
  placeholder,
  name,
  type,
  onClick,
  onChange,
  light,
  min,
  fieldValue = "",
  ref,
  isCombine = false,
  setSelectedId,
  isRadioBtn = "false",
  height = "5.1",
  isRequired = false,
  isFromDate = false,
  width = "25",
  borderRadius,
  searchTagsList,
  maxSelected = 1,
  isLimit = false,
  validationLabel = "",
  isMulti = false,
  options,
  selectedValues,
  isDisable = false,
  isDisabled = false,
  // onFilterSearch,
  // handleReset,
  isInputDisabled = false,
  setSelectedTag,
  selectedTag
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const [selectedValue, setSelectedValue] = useState([]);

  const [tagListRef, isTagListVisible, setTagListVisible] =
    useComponentVisible();
  useEffect(() => {
    if (type === "tags") {
      searchTagsList?.length > 0
        ? setTagListVisible(true)
        : setTagListVisible(false);
    } else {
      // setTagListVisible(true);
    }
  }, [type, searchTagsList, setTagListVisible]);

  // const [selectedTag, setSelectedTag] = useState();

  const handleAddTag = (value, name) => {
    setSelectedValue(value);
    setSelectedId(value);
    setSelectedTag(name);
    setTagListVisible(false);
  };

  return (
    <div
      className={classes.formGroup_main}
      style={{
        // display: isRadioBtn ? "inline-flex" : "",
        color: light ? "#707070" : "#404040",
      }}
    >
      {label && type !== "multiSelect" && (
        <div
          style={{
            display: "flex",
            width: width + "rem",
            paddingBottom: 10 + "px",
          }}
        >
          <label
            style={{ color: light ? "#707070" : "#404040" }}
            className={isRequired ? classes.inputLabel : classes.labels}
          >
            {label}
          </label>
          {isLimit && (
            <div className={classes.validationLabel}>
              <div>
                (Max: {maxSelected} {validationLabel})
              </div>
            </div>
          )}
        </div>
      )}
      <div className={classes.formGroup}>
        {type === "text" ? (
          <input
            ref={ref}
            type={type}
            value={value}
            name={name}
            className={classes.textForm}
            placeholder={placeholder}
            onChange={onChange}
            onClick={onClick}
            style={{
              width: width + "rem",
              height: height + "rem",
            }}
          />
        ) : type === "radio" ? (
          <input
            ref={ref}
            type={type}
            className={classes.radioForm}
            name={name}
            onClick={onClick}
            checked={value}
            onChange={onChange}
            style={{
              width: width + "rem",
              height: height + "rem",
            }}
          />
        ) : type === "checkbox" ? (
          <input
            ref={ref}
            type={type}
            className={classes.checkboxForm}
            checked={value}
            onChange={onChange}
          />
        ) : type === "file" ? (
          <div>
            <input
              ref={ref}
              type={type}
              className={classes.fileForm}
              name={name}
              value={value}
              placeholder={placeholder}
              onChange={onChange}
              height={height}
              width={width}
            />
          </div>
        ) : type === "date" ? (
          isFromDate ? (
            <input
              type={type}
              style={{
                width: width + "rem",
                height: height + "rem",
              }}
              value={value}
              onChange={onChange}
              max={today}
              className={classes.textForm}
              placeholder={placeholder}
            />
          ) : (
            <input
              type={type}
              style={{
                width: width + "rem",
                height: height + "rem",
              }}
              value={value}
              onChange={onChange}
              max={today}
              min={min ? moment(min).format("YYYY-MM-DD") : undefined}
              className={classes.textForm}
              placeholder={placeholder}
            />
          )
        ) : type === "textarea" ? (
          <input
            ref={ref}
            type={type}
            value={value}
            name={name}
            className={classes.textForm}
            placeholder={placeholder}
            onChange={onChange}
            style={{
              width: width + "rem",
              height: height + "rem",
            }}
          />
        ) : type === "password" ? (
          <>
            <div className={classes.inputTextBox__showPassword}>
              {showPassword === false ? (
                <img
                  src={passwordEyeIconOff}
                  onClick={() => setShowPassword(true)}
                  alt="show password"
                  width="16"
                />
              ) : (
                <img
                  src={passwordEyeIconOn}
                  onClick={() => setShowPassword(false)}
                  alt="show password"
                  width="16"
                />
              )}
            </div>
            <input
              ref={ref}
              type={
                type === "password"
                  ? showPassword === true
                    ? "text"
                    : "password"
                  : type
              }
              value={value}
              name={name}
              className={classes.textForm}
              placeholder={placeholder}
              onChange={onChange}
              style={{
                width: width + "rem",
                height: height + "rem",
              }}
            />
          </>
        ) : type === "tags" ? (
          <div
            className={classes.container}
            style={{
              position: "relative",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              width: width + "rem",
              height: height + "rem",
              gap: "1rem",
              borderRadius: borderRadius + "rem",
              // padding: type === "tags" ? "2% 10% 2% 2%" : "2%",
              backgroundColor: "#fff",
            }}
          >
            <input
              type="text"
              className={classes.textForm}
              placeholder={placeholder}
              onChange={onChange}
              value={selectedTag}
              onFocus={() => setSelectedTag()}
              style={{
                width: width + "rem",
                height: height + "rem",
              }}
            />
            {isTagListVisible && (
              <ul className={classes.options} ref={tagListRef}>
                {type === "tags" ? (
                  searchTagsList?.map((tag, index) => {
                    return (
                      <li
                        key={index}
                        className={classes.inputOptions}
                        onClick={() => handleAddTag(tag[fieldValue], tag.Name)}
                      >
                        {tag.Name}
                      </li>
                    );
                  })
                ) : (
                  <></>
                )}
              </ul>
            )}
          </div>
        ) : type === "multiSelect" ? (
          <Dropdown
            name={name}
            onChange={onChange}
            placeholder={placeholder}
            options={options}
            isRequired={isRequired}
            selectedValue={selectedValues}
            label={label}
            // light,
            validationLabel={validationLabel}
            height={height}
            width={width}
            isMulti={isMulti}
            maxSelected={maxSelected}
            isLimit={isLimit}
            isDisabled={isDisabled}
            isInputDisabled={isInputDisabled}
          />
        ) : type === "searchBtn" && isCombine ? (
          <div
            style={{
              display: "flex",
              gap: 2 + "rem",
              marginTop: 3 + "rem",
            }}
          >
            <span
              style={{
                textDecoration: "underline",
                color: "#0051BC",
                cursor: "pointer",
                paddingTop: "12px",
              }}
              onClick={onClick}
            >
              Reset
            </span>
            <Button
              label={<FormattedMessage id="SEARCH" />}
              dark
              small
              className={classes.searchButton}
              onClick={onClick}
            />
          </div>
        ) : type === "reset" ? (
          <span
            style={{
              textDecoration: "underline",
              color: "#0051BC",
              cursor: "pointer",
              paddingTop: "12px",
            }}
            onClick={onClick}
          >
            <FormattedMessage id="RESET_MSG" />
          </span>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Input;
